import { render, staticRenderFns } from "./-OrderSummaryWidget.vue?vue&type=template&id=88b2bb72&scoped=true"
import script from "./-OrderSummaryWidget.vue?vue&type=script&lang=js"
export * from "./-OrderSummaryWidget.vue?vue&type=script&lang=js"
import style0 from "./-OrderSummaryWidget.vue?vue&type=style&index=0&id=88b2bb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b2bb72",
  null
  
)

export default component.exports